(function(angular) {
  'use strict';

  angular.module('asSecureCommerce', ['osiAssets', 'ngSanitize']);
})(window.angular);
